import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ApiService } from "src/app/services/api.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import endpoints from "src/app/helpers/endpoints";
import { ErrorType } from "src/app/enums/error-type.enum";
import { FormControl, FormGroup } from "@angular/forms";
import * as moment from 'moment';

@Component({
  selector: "fury-partner-dashbaord",
  templateUrl: "./partner-dashbaord.component.html",
  styleUrls: ["./partner-dashbaord.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  encapsulation: ViewEncapsulation.None,
})
export class PartnerDashbaordComponent implements OnInit {
  partnerDashboardData: any;
  ngUnSubscribe = new Subject<void>();
  partnerId = "";
  dashboardData: any = {};
  dateRangePickerForm = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  today = new Date();
  startDate: null|string = null;
  endDate: null|string = null;

  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((paramMap: any) => {
        this.partnerId = paramMap.get("id");
        if (this.partnerId) this.getLeadPartnerDashboardData();
      });
  }

  getLeadPartnerDashboardData() {
    this.apiService
      .get(
        `${endpoints.leadPartner.getParticularLeadPartnerDashboard(this.partnerId)}${this.startDate ? '?startDate=' + this.startDate : ''}${this.endDate ? '&endDate=' + this.endDate: ''}`
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.dashboardData = res.body?.dashboardData;
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.error?.message, ErrorType.Error);
        },
      });
  }

  redirectToDashboard() {
    this.router.navigateByUrl(`lead-partners/partner-list`);
  }

  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    if(this.dateRangePickerForm.valid){
      if(this.dateRangePickerForm.value.start && !this.dateRangePickerForm.value.end){
        this.dateRangePickerForm.markAllAsTouched();
        return;
      }
      this.startDate = this.dateRangePickerForm.value.start? moment(this.dateRangePickerForm.value.start).format('YYYY-MM-DD HH:mm:ss'): null;
      this.endDate = this.dateRangePickerForm.value.end ? moment(this.dateRangePickerForm.value.end).format('YYYY-MM-DD HH:mm:ss'): null;
     this.getLeadPartnerDashboardData();
    }
  };
  clearDaterangePicker(){
    if(this.dateRangePickerForm.value.start){
      this.dateRangePickerForm.patchValue({
        start: null,
        end: null,
      });
      this.startDate = null;
      this.endDate = null;
      this.getLeadPartnerDashboardData();
    }
    
  }

  ngOnDestroy(): void {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
